import Icon from '../Icon';
import { IconSpan } from './CTA.styles';
import defaultTheme from '../../../themes/fse/theme';

const {
  primaryFontSize,
  primaryFontSizeMd,
  primaryPaddingX,
  primaryPaddingXMd,
  primaryPaddingY,
  primaryPaddingYLg,
  primaryPaddingYMd,
} = defaultTheme.cta;
/** Border thickness for CTA buttons */
export const borderThickness = 2;

/**
 * Get horizontal padding based on CTA size
 *
 * @param {'SMALL' | 'MEDIUM' | 'LARGE'} size - The size of the CTA button
 * @returns {number} The horizontal padding in pixels
 */
export const getPaddingX = (size) =>
  size === 'MEDIUM' ? primaryPaddingXMd : primaryPaddingX;

/**
 * Get vertical padding based on CTA size
 * Note: These are custom values that don't align with the spacing scale
 * but are necessary to maintain the designed button heights
 *
 * @param {'SMALL' | 'MEDIUM' | 'LARGE'} size - The size of the CTA button
 * @returns {number} The vertical padding in pixels
 */
export const getPaddingY = (size) => {
  if (size === 'LARGE') return primaryPaddingYLg;
  if (size === 'MEDIUM') return primaryPaddingYMd;
  return primaryPaddingY;
};

/**
 * Get font size based on CTA size
 *
 * @param {'SMALL' | 'MEDIUM' | 'LARGE'} size - The size of the CTA button
 * @returns {string} The font size in pixels
 */
export const getFontSize = (size) =>
  size === 'MEDIUM' ? primaryFontSizeMd : primaryFontSize;

/**
 * Helper to render icon (before/after)
 *
 * @param {object} params
 * @param {IconType | undefined} params.iconName - name of the icon
 * @param {'Before' | 'After'} params.position - position of the icon
 * @param {CtaSkinType} params.skin
 * @param {boolean} params.isArrowAnimated
 * @param {boolean} params.hovered
 * @param {boolean} params.isNavigation
 * @param {number | [number, number] | undefined} params.rotation - Rotation in degrees. If the original prop was an array it has already been normalized per icon before this helper is called, so here we always receive the single numeric value relevant for this icon.
 * @param {number | undefined} params.width
 * @param {number | undefined} params.height
 * @returns {React.ReactElement | null} The rendered icon element or null
 */
export const renderCTAIcon = ({
  iconName,
  position,
  skin,
  isArrowAnimated,
  hovered,
  isNavigation,
  rotation,
  width,
  height,
}) => {
  if (!iconName || skin === 'LINK') return null;

  return (
    <IconSpan
      className={`icon${position} ${isArrowAnimated ? 'arrowAnimated' : ''}`}
    >
      <Icon
        icon={iconName}
        checked={hovered}
        rotation={rotation}
        width={width}
        height={height}
        {...(isNavigation && { tag: 'none' })}
      />
    </IconSpan>
  );
};
